import { HOME_PRODUCT_KEYS } from '@/config/navigation/secondaryNav'
import PATHS from '@/routes/paths'
import { buildAppShellNavHandlersProps } from './buildAppShellNavHandlersProps.js'
import { accountFromSession } from './sessionAccount.js'

export { resolveAppShellHomeNav } from './resolveAppShellHomeNav.js'

export function buildAppShellSecondaryNavProps({
  chat,
  handlers,
  homeThreads,
  homePinnedIds,
  session,
  projects,
  projectActions,
}) {
  const account = accountFromSession(session)
  return {
    activeKey: chat.activePrimaryKey,
    homeProduct: chat.homeProduct ?? HOME_PRODUCT_KEYS.CHAT,
    onAccountMenuAction: chat.handleAccountMenuAction,
    accountFullName: account.fullName,
    accountEmail: account.email,
    activeView: chat.activePrimaryKey === 'home' ? chat.homeView : undefined,
    documentsActive: chat.location.pathname === PATHS.DOCUMENTS,
    doVoiceActive: chat.location.pathname === PATHS.DO_VOICE,
    schedulesActive: chat.location.pathname === PATHS.SCHEDULES,
    triggersActive: chat.location.pathname === PATHS.TRIGGERS,
    skillsActive: chat.location.pathname === PATHS.SKILLS,
    connectionsActive: chat.location.pathname === PATHS.CONNECTIONS,
    buildActive: chat.location.pathname === PATHS.BUILD,
    myAppsActive:
      chat.homeProduct === HOME_PRODUCT_KEYS.CODE &&
      chat.location.pathname === PATHS.HOME &&
      chat.activePrimaryKey === 'home' &&
      !chat.displayThreadId,
    threads: homeThreads,
    projects,
    pinnedProjectIds: projects ? [] : undefined,
    selectedProjectId: chat.activeProjectId,
    selectedThreadId: chat.activePrimaryKey === 'home' ? chat.displayThreadId : null,
    pinnedThreadIds: homePinnedIds,
    ...buildAppShellNavHandlersProps({ chat, handlers, projectActions }),
  }
}
